import { useQuery } from '@apollo/client';

import { FETCH_WORK_ASSIGNMENT } from './gql/fetchWorkAssignment';

const NOT_FOUND = new Error('Work assignment not found');

export function useResolvedAssignment({ crewMemberId, sequenceGroupId, fullAssignmentData }) {
	const skip = Boolean(fullAssignmentData);

	const { data, loading, error } = useQuery(FETCH_WORK_ASSIGNMENT, {
		variables: {
			filter: {
				crewMemberIds: [crewMemberId],
				sequenceGroupIds: [sequenceGroupId],
			},
			pagination: { page: 0, size: 1 },
		},
		fetchPolicy: 'no-cache',
		skip,
	});

	if (fullAssignmentData) {
		return { data: fullAssignmentData, loading: false, error: null };
	}

	if (loading) {
		return { data: null, loading: true, error: null };
	}

	if (error) {
		return { data: null, loading: false, error };
	}

	const result = data?.workAssignmentSearchV2?.results?.[0] ?? null;
	if (!result) {
		return { data: null, loading: false, error: NOT_FOUND };
	}

	return { data: result, loading: false, error: null };
}
